export * from './indicators'
export * from './statuses'
export * from './resolutions'
export * from './reports'

export const CHANGELOG_SUBJECT_TYPE = 'App\\Models\\OuterReclamation\\OuterReclamation'
